require("@rails/ujs").start()

import { trackEvent } from '../analytics';

import 'lazysizes';

import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import '../javascript/index'
import '../javascripts/autocomplete.js'

import '../styles.scss'

import '../stylesheets/iconfont_iconfont.scss';

import 'pc-bootstrap4-datetimepicker/build/js/bootstrap-datetimepicker.min';

require("bootstrap/dist/js/bootstrap")

window.$ = $;
$(() => {

  $('#program').on('hide.bs.collapse', function (e) {
    $('.itinerary').removeClass('itinerary--active');
  });
  $('#program').on('show.bs.collapse', function (e) {
    $(e.target).closest('div.itinerary').addClass('itinerary--active');
  })
  $('#program').on('shown.bs.collapse', function (e) {
    $(e.target).closest('div.itinerary').addClass('itinerary--active');
  })

  $('#program .collapse').collapse();

  if (window.Fancybox) {
    Fancybox.bind('[data-fancybox="gallery"]', {
      animated: false,
    })
  }

  // Homepage filter
  $('#date-from').datetimepicker({
    format: 'DD.MM.YYYY',
  });

  $('#date-to').datetimepicker({
    format: 'DD.MM.YYYY',
    useCurrent: false //Important! See issue #1075
  });

  $("#date-from").on("dp.change", function (e) {
      $('#date-to').data("DateTimePicker").minDate(e.date);
  });

  $("#date-to").on("dp.change", function (e) {
      $('#date-from').data("DateTimePicker").maxDate(e.date);
  });

  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    // Remove the highlighted class from all nav items
    $(e.target).closest('.list-group').find('.menu-pill__item').removeClass('menu-pill__item--highlighted');

    // Add the highlighted class to the parent nav item of the activated tab
    $(e.target).closest('.menu-pill__item').addClass('menu-pill__item--highlighted');
  });

  $('.request-button').on('click', function() {
    var date = $(this).data('date');

    const customEvent = new CustomEvent('requestDate', { detail: { date } });
    document.dispatchEvent(customEvent);

    trackEvent('date_selected', { date: date });
  });

  // Track form_start on first interaction with any tracked form
  $(document).on('focusin', 'form[data-track-form]', function() {
    var formName = $(this).data('track-form');
    trackEvent('form_start', { form_name: formName });
    // Fire only once per form instance
    $(this).off('focusin');
  });

  // Track AJAX form submissions
  $(document).on('ajax:success', 'form[data-track-form]', function() {
    var formName = $(this).data('track-form');
    if (formName === 'newsletter') {
      trackEvent('sign_up', { method: 'newsletter_form' });
    } else {
      trackEvent('generate_lead', { form_name: formName });
    }
  });

  $(document).on('ajax:error', 'form[data-track-form]', function() {
    var formName = $(this).data('track-form');
    trackEvent('form_error', { form_name: formName });
  });
});
